import React from 'react'
import ContentArea from '../components/ContentArea'

const IntroMeditatePage = () => {
  return (
    <ContentArea>
      <h2>What is mindfulness?</h2>
      <p>
        Mindfulness is about being aware in the present moment with attitudes of curiosity, kindness
        and openness. When we are mindful we can meet the ordinary and extraordinary challenges of
        our lives with greater clarity and less reactivity. We can also be more present to the joys
        and beauty in our lives.{' '}
      </p>
      <p>
        The intention of the mindfulness meditation practices is to strengthen our ability to be
        present rather than lost in thoughts about the past or worries about the future.
      </p>
      <h2>What we offer</h2>
      <p>
        There are two types of mindfulness meditation practices offered here - Body Scan and Breath
        Awareness meditations. For each of these you can choose the length of time you want to
        practice (varying from 5 minutes to 25 minutes).
      </p>
      <h2>During the meditation</h2>
      <p>
        It is important for you to take care of yourself while practicing, being in a place where
        you feel as comfortable as possible. Both of these practices can be done in any posture,
        whether sitting or lying down.{' '}
      </p>
      <p>
        In the body scan meditation, you will be guided to bring your attention to sensations in the
        body, moving from one region to another. You will be invited to notice whatever is present
        with an attitude of non-judgment, care and kindness. There is no “right way” to feel,
        nothing specific to search for. Simply allowing what is present to be as it is and allowing
        yourself to be as you are.{' '}
      </p>
      <p>
        In the breath awareness meditation, you will be guided to bring your attention to the
        sensations of breathing wherever you feel the breath most vividly. With this practice, there
        is no need to change or control the breath. Rather, simply follow the natural rhythm of the
        breath as it comes and goes. It is very natural for the mind to wander and get lost in
        thoughts. As soon as you notice that the mind has wandered, gently bring your attention back
        to the breath, treating yourself with kindness and letting go of any judgmental and critical
        thoughts.{' '}
      </p>
      <p>
        This act of bringing the attention back again and again is what cultivates your ability to
        be present and show up fully for your life.{' '}
      </p>
      <p>
        See if you can allow mindfulness meditation practice to be a nourishing time, a time to give
        yourself some positive energy and attention, a time to open to the sources of strength and
        healing that are within you.
      </p>
      <h2>What Are the Benefits of Practicing Mindfulness Meditation?</h2>
      <p>There are many scientifically documented benefits of practicing mindfulness including:</p>
      <ul>
        <li>Reduced anxiety and depression</li>
        <li>Reduced pain</li>
        <li>Decreased blood pressure </li>
        <li>Improved immune function </li>
        <li>Improved cognitive function (memory & concentration) </li>
        <li>Improved emotional regulation</li>
      </ul>
      <h2>Ways to Practice Mindfulness</h2>
      <p>
        There are numerous ways to learn how to practice mindfulness meditation. One way is to
        listen to guided meditation recordings similar to what you will find on this web app.
        Another way is to take a course in mindfulness-based stress reduction (MBSR). The
        Myrna-Brind Center for Mindfulness at the Marcus Institute of Integrative Health at
        Jefferson has been offering MBSR for 25 years, helping thousands of people to reduce
        anxiety, depression, and pain and enhance wellbeing.
      </p>
      <p>
        The Marcus Institute of Integrative Health at Jefferson is committed to improving patient
        outcomes with world class integrative care. For more information about the Marcus Institute
        and Mindfulness programs, visit:
        </p>
      <a href="https://marcusinstitute.jeffersonhealth.org/services/mindfulness-programs.html">
        Marcus Mindfulness
        </a>
    </ContentArea>
  )
}

export default IntroMeditatePage
